import { Inventory2Outlined } from "@mui/icons-material";
import { Box, Button, Checkbox, Chip, MenuItem, Select, Stack, Typography } from "@mui/material";
import { Dispatch, FC, Fragment, SetStateAction, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

interface IFormMultiSelectProps {
  value: any[];
  setValue: Dispatch<SetStateAction<any[]>>;
  options: any[];
  renderOption: (option: any) => string;
  renderInput: (option: any) => string;
  objectName: string;
  startIcon: React.ReactNode;
  maxItems?: number;
}

const FormMultiSelect: FC<IFormMultiSelectProps> = (props) => {
  const { t } = useTranslation();
  const { value, setValue, renderOption, renderInput, startIcon, objectName, options, maxItems = 3 } = props;

  const [menuOpened, setMenuOpened] = useState(false);

  const handleMoreClose = () => {
    setMenuOpened(false);
  };

  return (
    <Select
      multiple
      value={value}
      onChange={(e) => setValue(e.target.value as [])}
      onOpen={(e) => setMenuOpened(true)}
      onClose={(e) => setMenuOpened(false)}
      open={menuOpened}
      autoWidth
      displayEmpty
      MenuProps={{
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left",
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left",
        },
        sx: { maxHeight: 500 },
      }}
      renderValue={(value) => {
        if (value.length === 0)
          return (
            <>
              {startIcon}
              <Typography color="text.secondary" sx={{ ml: 1 }}>
                {t("common:all")} {objectName}
              </Typography>
            </>
          );
        return (
          <Stack direction="row" alignItems={"center"} gap={1}>
            {startIcon}
            <Stack direction="row" gap={0.5}>
              {value.length > 0 &&
                value.slice(0, maxItems).map((option, index) => (
                  <Fragment key={`key-${option}-${index}`}>
                    <Chip variant="outlined" size="medium" label={renderInput(option)} />
                    {index === maxItems - 1 && value.length - maxItems > 0 && (
                      <Chip variant="outlined" label={`+${value.length - 3}`} />
                    )}
                  </Fragment>
                ))}
            </Stack>
          </Stack>
        );
      }}
      sx={{ height: 32 }}
    >
      {value.length > 0 && (
        <Box
          sx={(theme) => ({
            position: "sticky ",
            top: 0,
            background: theme.palette.background.default,
            zIndex: 1,
          })}
        >
          <Button
            variant="outlined"
            fullWidth
            onClick={(e) => {
              e.stopPropagation();
              setValue([]);
              handleMoreClose();
            }}
          >
            {t("button:clearSelection")}
          </Button>
        </Box>
      )}
      {options.map((option, i) => (
        <MenuItem key={`${option}-${i}`} value={option} dense sx={{ pl: 0, pr: 1, py: 0 }}>
          <Checkbox checked={value.includes(option)} />
          <Typography color={"text.primary"}>
            {/* handle more infos than just a string */}
            {renderOption(option)}
          </Typography>
        </MenuItem>
      ))}
    </Select>
  );
};

export default FormMultiSelect;
